import { h } from 'preact';
import ChatActiveIcon from './icon-components/ChatActiveIcon';
import ChatIcon from './icon-components/ChatIcon';
import CloseIcon from './icon-components/CloseIcon';
import EcoActiveIcon from './icon-components/EcoActiveIcon';
import EcoIcon from './icon-components/EcoIcon';
import EmbedIcon from './icon-components/EmbedIcon';
import EyeLiveIcon from './icon-components/EyeLiveIcon';
import FullscreenOffIcon from './icon-components/FullscreenOffIcon';
import FullscreenOnIcon from './icon-components/FullscreenOnIcon';
import LinkIcon from './icon-components/LinkIcon';
import PipIcon from './icon-components/PipIcon';
import PlaylistActiveIcon from './icon-components/PlaylistActiveIcon';
import PlaylistIcon from './icon-components/PlaylistIcon';
import RemoteControlActiveIcon from './icon-components/RemoteControlActiveIcon';
import RemoteControlIcon from './icon-components/RemoteControlIcon';
import SettingsIcon from './icon-components/SettingsIcon';
import StarActiveIcon from './icon-components/StarActiveIcon';
import StarIcon from './icon-components/StarIcon';
import TracksActiveIcon from './icon-components/TracksActiveIcon';
import TracksIcon from './icon-components/TracksIcon';
import VolumeLowIcon from './icon-components/VolumeLowIcon';
import VolumeMaxIcon from './icon-components/VolumeMaxIcon';
import VolumeModerateIcon from './icon-components/VolumeModerateIcon';
import VolumeMuteIcon from './icon-components/VolumeMuteIcon';

export const STANDARD_ICONS = (props) => ({
  tracks: <TracksIcon {...props} />,
  'tracks-active': <TracksActiveIcon {...props} />,
  pip: <PipIcon {...props} />,
  'fullscreen-off': <FullscreenOffIcon {...props} />,
  'fullscreen-on': <FullscreenOnIcon {...props} />,
  embed: <EmbedIcon {...props} />,
  eco: <EcoIcon {...props} />,
  'eco-activated': <EcoActiveIcon {...props} />,
  settings: <SettingsIcon {...props} />,
  'volume-mute': <VolumeMuteIcon {...props} />,
  'volume-low': <VolumeLowIcon {...props} />,
  'volume-moderate': <VolumeModerateIcon {...props} />,
  'volume-max': <VolumeMaxIcon {...props} />,
  'eye-live': <EyeLiveIcon {...props} />,
  close: <CloseIcon {...props} />,
  remoteControl: <RemoteControlIcon {...props} />,
  remoteControlActive: <RemoteControlActiveIcon {...props} />,
  star: <StarIcon {...props} />,
  starActive: <StarActiveIcon {...props} />,
  chat: <ChatIcon {...props} />,
  chatActive: <ChatActiveIcon {...props} />,
  playlist: <PlaylistIcon {...props} />,
  'playlist-active': <PlaylistActiveIcon {...props} />,
  linkIcon: <LinkIcon {...props} />
});
